import { customTemplates } from "../CustomTemplates.js";
export function registerCustomTemplates(storyboard) {
  var _storyboard$meta;
  if (storyboard.$$registerCustomTemplateProcessed) {
    return;
  }
  storyboard.$$registerCustomTemplateProcessed = true;
  const templates = (_storyboard$meta = storyboard.meta) === null || _storyboard$meta === void 0 ? void 0 : _storyboard$meta.customTemplates;
  if (Array.isArray(templates)) {
    for (const tpl of templates) {
      const tagName = tpl.name.includes(".") ? tpl.name : `${storyboard.app.id}.${tpl.name}`;
      customTemplates.define(tagName, tpl);
    }
  }
}
//# sourceMappingURL=registerCustomTemplates.js.map